import type { JSX, ReactNode } from 'react';

export function Row({
  label,
  value,
  emphasis = false,
}: {
  label: ReactNode;
  value: ReactNode;
  emphasis?: boolean;
}): JSX.Element {
  return (
    <div
      className={`flex items-baseline justify-between gap-4 py-1.5 text-sm ${emphasis ? 'border-t border-slate-200 pt-3 text-base font-semibold dark:border-slate-700' : ''}`}
    >
      <span
        className={
          emphasis ? 'text-slate-900 dark:text-slate-100' : 'text-slate-500 dark:text-slate-400'
        }
      >
        {label}
      </span>
      <span
        className={
          emphasis
            ? 'text-slate-900 dark:text-slate-100'
            : 'text-slate-900 dark:text-slate-100 tabular-nums'
        }
      >
        {value}
      </span>
    </div>
  );
}
